module.exports = __webpack_public_path__ + "static/media/e-infinitiv.367a1be3.mp3";